import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Avatar } from '@mui/material';
import { team } from '../data/team';

const Team = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        minHeight: '100vh',
        p: { xs: 2, sm: 4 },
        backdropFilter: 'blur(5px)',
        overflowX: 'hidden',
      }}
    >
      <Typography
        variant="h3"
        color="primary"
        gutterBottom
        sx={{ fontSize: { xs: '2rem', sm: '3rem' }, textAlign: 'center' }}
      >
        Our Team
      </Typography>

      <Grid container spacing={{ xs: 2, sm: 3 }}>
        {team.map((member) => (
          <Grid
            key={member.id}
            item
            xs={12}
            sm={6}
            md={4}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Card
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                width: { xs: 160, sm: 200 },
                height: { xs: 160, sm: 200 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 6,
                },
              }}
            >
              <Avatar
                src={member.image}
                alt={member.name}
                sx={{ width: { xs: 120, sm: 150 }, height: { xs: 120, sm: 150 } }}
              />
              <CardContent sx={{ textAlign: 'center', p: 1 }}>
                <Typography variant="h6" color="primary" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                  {member.name}
                </Typography>
                <Typography variant="body2" color="white" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                  {member.role}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Team;
